<template>
	<v-sheet color="transparent">

		<h2 class="mb-5 cn-font grey--text">Teams</h2>
				<!-- 	<p>
						Im Rahmen der Reifegraderhebung stellen wir Ihnen verschiedene Tools zur Verfügung, die Ihnen das Zusammenarbeiten mit Anderen erleichtern sollen. In diesem Sinne stehen Ihnen die folgenden Möglichkeiten zur Verfügung:
					</p> -->
					<v-row>
						<v-col cols="12" sm="6" lg="3">
							<v-card>
								<v-card-title>
									<v-icon class="mr-2">mdi-hospital-building</v-icon>
									Gesamtdelegation
								</v-card-title>
								<v-card-text>
									<p>Die Gesamtdelegation ermöglicht es Ihnen, Erhebungsteile nach unserem vordefinierten Schema an Andere zu delegieren und somit mühelos die sachgerechte Bearbeitung der Reigfegraderhebung zu gewähleisten Mehr informationen zum Schema finden sie hier.</p>
								</v-card-text>
<!-- 								<v-card-actions style="position: absolute; bottom: 0; width: 100%">
									<div class="text-center mb-5" style="width: 100%">
										<v-icon class="mr-2" large>mdi-account</v-icon>
										<v-icon class="mr-2" large>mdi-arrow-left-right-bold-outline</v-icon>
										<v-icon class="mr-2" large>mdi-hospital-building</v-icon>
									</div>
								</v-card-actions>
 -->
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn link to='schnelldelegation' color="primary" rounded>Mehr</v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col cols="12" sm="6" lg="3">
							<v-card>
								<v-card-title>
									<v-icon class="mr-2" color="primary">mdi-clipboard-flow</v-icon>
									Teildelegation
								</v-card-title>
								<v-card-text>
									<p>Beteiligen Sie weitere Personen individuell an spezifischen Erhebungsteilen.</p>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12" sm="6" lg="3">
							<v-card>
								<v-card-title>
									<v-icon class="mr-2" color="accent">mdi-account-multiple-check</v-icon>Quick-Poll
								</v-card-title>
								<v-card-text>
									<p>Erstellen Sie gruppenspezifische Umfragen und Abstimmungen für eine noch aussagekräftigere Erhebung.</p>							
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12" sm="6" lg="3">
							<v-card class="mb-4">
								<v-card-title>
									<v-icon class="mr-2" color="green">mdi-contacts</v-icon>Teams & Kontakte
								</v-card-title>
								<v-card-text>
									<p>Verwalten sie alle an der Erhebung beteiligten Teammitglieder zentral.</p>											
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn link to="groups" color="primary" rounded>Mehr</v-btn>
								</v-card-actions>
							</v-card>
							<v-card>
								<v-card-title>
									<v-icon class="mr-2" color="green">mdi-account-group</v-icon>Zusammenarbeitsvorgänge
								</v-card-title>
								<v-card-text>
									<p>Nutzen Sie die übersichtliche Darstellung aller aktiven aktiven Zusammenarbeitsvorgänge, um Ihre Erhebung so effizient wie möglich zu gestalten.</p>											
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn link to="collaborations" color="primary" rounded>Mehr</v-btn>
								</v-card-actions>

							</v-card>
						</v-col>
					</v-row>
			
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	export default {
		name: "Teams", 
		props: {
			
		},
		data: () => {
			return {
			}
		},
		components: {
		},
		computed: {
		},
		methods: {
		}
		// created(){
			
		// }

	}
</script>